import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private http: HttpClient) { }

  getSurveys(): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys`;
    return this.http.get(url);
  }

  createSurvey(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys`;
    return this.http.put(url, value);
  }

  getSurvey(surveyId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys/${surveyId}`;
    return this.http.get(url);
  }

  getMySurveys(): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys/my-surveys`;
    return this.http.get(url);
  }
  getMySurvey(surveyId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys/${surveyId}`;
    return this.http.get(url);
  }
  deleteSurvey(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys/${id}`;
    return this.http.delete(url);
  }
  updateSurveyField(surveyId: string, name: string, value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/surveys/${surveyId}`;
    const field: any = {};
    field.name = name;
    field.value = value;
    return this.http.post(url, field);
  }
}
